import { render, staticRenderFns } from "./CreateOrUpdateSubGroup.vue?vue&type=template&id=a4f7819c"
import script from "./CreateOrUpdateSubGroup.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateSubGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports